import React, { useState } from 'react';
import JobProductDataTable from "../../datatables/JobProductDataTable";
import ReactDOM from "react-dom";
import JobProductCreateEditPage from "../JobProductCreateEditPage";

export const PRODUCT_PAGES = {
    INDEX:  'index',
    CREATE: 'create',
    EDIT:   'edit',
}

const JobProductPage = (props) => {
    const {
        jobId       = null,
        productId   = null,
        page        = PRODUCT_PAGES.INDEX,
        parentId    = "",
    } = props;

    const [currentPage, setCurrentPage]                 = useState(page);
    const [selectedJobProduct, setSelectedJobProduct]   = useState(!!productId ? {id: productId} : null);

    const handleChangePage = (page, product) => {
        switch (page) {
            case PRODUCT_PAGES.INDEX:
                window.history.pushState({}, '', route('job.product.index', {job: jobId}).toString());
                break;
            case PRODUCT_PAGES.CREATE:
                window.history.pushState({}, '', route('job.product.create', {job: jobId}).toString());
                break;
            case PRODUCT_PAGES.EDIT:
                window.history.pushState({}, '', route('job.product.edit', {job: jobId, product: product.id}).toString());
                break;
        }

        setCurrentPage(page);
        setSelectedJobProduct(product);
    }

    switch (currentPage) {
        case PRODUCT_PAGES.EDIT:
            return (
                <JobProductCreateEditPage
                    jobId={jobId}
                    productId={!!selectedJobProduct && !!selectedJobProduct.id ? selectedJobProduct.id : null}
                    onChangePage={(page, product) => handleChangePage(page, product)}
                    parentId={parentId}
                />
            );
        case PRODUCT_PAGES.CREATE:
            return (
                <JobProductCreateEditPage
                    jobId={jobId}
                    productId={null}
                    onChangePage={(page, product) => handleChangePage(page, product)}
                    parentId={parentId}
                />
            );
        case PRODUCT_PAGES.INDEX:
        default:
            return (
                <JobProductDataTable
                    jobId={jobId}
                    onChangePage={(page, product) => handleChangePage(page, product)}
                    parentId={parentId}
                />
            )
    }
}

export default JobProductPage;

const target = document.getElementById('job-product-page');
if (target) {
    const {
        jobId       = null,
        productId   = null,
        page        = PRODUCT_PAGES.INDEX,
        parentId    = 'job-product-page'
    } = target.dataset;

    ReactDOM.render(
        <JobProductPage
            jobId={jobId}
            productId={!!productId ? productId : null}
            page={page}
            parentId={parentId}
        />
    , target);
}

